import axios from "axios"
import { LOCAL_TOKEN } from "../utils/storage"

export const updateCheckOrganigram = (data = {}) => {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${data.measure}/checkorganigram`,
    data,
  })
}

export const resendSurveyToNews = (data = {}) => {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${data.measure}/send/recipients`,
    data,
  })
}
